export enum WarrantyOperationType {
  ASSOCIATE = 1,
  ACTIVATE = 2,
  EXTEND = 3,
  VOID_EXTENSION = 4,
  VOID = 5,
  DISASSOCIATE = 6,
  REPAIR = 7
}
